import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import Questions from "./questions";
import Results from "./results";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="Questions" element={<Questions />} />
      <Route path="Results" element={<Results />} />
    </Routes>
  </BrowserRouter>
);

reportWebVitals();
